import { Customer } from '../../customer/customer.model';

export class UserCollect extends Customer {
    name: string;
}
    


// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/users/users-collect/user-collect.model.ts